/**
 * Authenticated fetch helper. Pulls a fresh Clerk session token for every
 * request — Clerk caches and refreshes it transparently. The hook returns a
 * stable function reference, so callers can pass it through useCallback deps.
 */
import { useAuth } from "@clerk/clerk-react";
import { useCallback } from "react";

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async <T = unknown>(path: string, init: RequestInit = {}): Promise<T> => {
      const token = await getToken();
      const res = await fetch(path, {
        ...init,
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          ...(init.headers ?? {}),
        },
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(`${res.status}: ${text}`);
      }
      return (await res.json()) as T;
    },
    [getToken],
  );
}
